import { render, staticRenderFns } from "./SubscriptionCtaPopup.vue?vue&type=template&id=5fa22268&scoped=true&"
import script from "./SubscriptionCtaPopup.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCtaPopup.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCtaPopup.vue?vue&type=style&index=0&id=5fa22268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa22268",
  null
  
)

export default component.exports